import React, { useState } from "react";
import MyModal from "../Common/MyModal";
import { Button } from "react-bootstrap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import {
  useAddTicketToEventMutation,
  useGetEventSolutionsQuery,
} from "../store/slices/settingsSlice";
import { toast } from "react-toastify";
import FullScreenLoadingIndicator, {
  AbsoluteLoadingIndicator,
} from "../Common/FullScreenLoadingIndicator";

export default function EventAddTicketModal({ eventData, eventSolution }) {
  const [ticket, setTicket] = useState("");
  const [description, setDescription] = useState("");
  const [addTicket] = useAddTicketToEventMutation();
  const [loading, setLoading] = useState(false);

  return (
    <div className="">
      <MyModal
        label=" Add Ticket"
        buttonClassName="bg-colored-reverse px-3 rounded-pill btn-sm border-0 fw-bold text-white text-nowrap p-1"
        heading="Add Ticket"
      >
        <AbsoluteLoadingIndicator loading={loading} />
        <div className="bg-white p-3 rounded-2 my-3">
          Add existing ticket or leave blank to generate a new one.
          <Input
            label="Add Ticket to Event"
            value={[ticket]}
            onChange={([v]) => setTicket(v)}
            options={[]}
            className="my-2"
          />
          <Input
            label="Description (optional)"
            value={[description]}
            onChange={([v]) => setDescription(v)}
            options={[]}
            className="my-2"
          />
        </div>
        <div className="d-flex justify-content-end">
          <Button
            className="bg-colored-reverse px-3 rounded-pill  border-0 btn-sm fw-bold mt-3"
            onClick={async () => {
              setLoading(true);
              const res = await addTicket({
                SolutionClientUuid: eventSolution.Uuid,
                ID: eventData.Reference,
                Ticket: ticket,
                Description: description,
              });
              if ("data" in res) {
                toast.success("Ticket added to event successfully");
              }
              setTimeout(() => {
                setLoading(false);
              }, 300);
            }}
            disabled={loading}
          >
            <div className="text-white"> Add Ticket</div>
          </Button>
        </div>
      </MyModal>
    </div>
  );
}
